import { useCallback, useMemo } from 'react'
import SearchBar from '../../../../../../../../baseComponents/SearchBar'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { getEmployees, getGroups } from '../../../../../../../../utils/reducers/getters'
import { CustomSelectWithSearchBar } from '../../../../../../../../forms/CustomSelect'
import { addDictionaryExtraLine } from '../../../../../../../../utils/globals/dictionary'
import { TaskCFieldValueModelType } from '@teinor/erp/types/company/task/taskCFieldValue'
import { TaskCFieldFiltersTy } from '../types'

interface TaskCFieldsFlowSubHeaderProps extends TaskFlowHeaderLogicProps {
    statuses: TaskCFieldValueModelType[]
    filters: TaskCFieldFiltersTy
}

const TaskFlowSubHeader: React.FC<TaskCFieldsFlowSubHeaderProps> = ({ setFilters, filters }) => {
    const { t } = useTwinTranslation()
    const { changeField } = useTaskFlowHeaderLogic({ setFilters })
    const myEmployees = useMemo(() => addDictionaryExtraLine(JSON.parse(JSON.stringify(getEmployees() || {}))), [])
    const myGroups = useMemo(() => addDictionaryExtraLine(JSON.parse(JSON.stringify(getGroups() || {}))), [])
    
    return (
        <div className='flex items-end gap-x-30 flex-wrap gap-y-10'>
            <div className='table_searcher_header'>
                <SearchBar className='search_bar_table' placeholder={t('searchDots', 'Buscar...')} searchValue={filters.searchValue} onChange={(value) => changeField('searchValue', value)} />
            </div>
            <CustomSelectWithSearchBar sortItems={true} className='w-200' label={t('assignedEmployee', 'Empleado asignado')} value={filters.selectedEmployeeId || ''} items={myEmployees || {}} fieldName={'fullname_short'} onChange={(value) => changeField('selectedEmployeeId', value)} />
            <CustomSelectWithSearchBar sortItems={true} className='w-200' label={t('assignedGroup', 'Grupo asignado')} value={filters.selectedGroupId || ''} items={myGroups || {}} onChange={(value) => changeField('selectedGroupId', value)} />
        </div>
    )
}

interface TaskFlowHeaderLogicProps {
    setFilters: React.Dispatch<React.SetStateAction<TaskCFieldFiltersTy>>
}

const useTaskFlowHeaderLogic = ({setFilters}: TaskFlowHeaderLogicProps) => {
    const changeField = useCallback((field: keyof TaskCFieldFiltersTy, value: any) => {
        setFilters((old) => {
            const oldCopy = JSON.parse(JSON.stringify(old))
            return {...oldCopy, [field]: value}
        })
    }, [setFilters])
    return { changeField }
}


export default TaskFlowSubHeader